/**
 * フレンドリクエスト一覧を取得するカスタムフック
 */

import useSWR from 'swr'
import { useAuth } from '~/contexts/AuthContext'
import { getFriendRequests } from '../services/api/friendService'
import type { FriendRequest } from '../types/friend'

const DEFAULT_REQUESTS: FriendRequest[] = []

interface UseFriendRequestsResult {
  requests: FriendRequest[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

// SWRのfetcher関数
const fetcher = async () => {
  const response = await getFriendRequests()
  return response.requests
}

export function useFriendRequests(): UseFriendRequestsResult {
  const { isAuthenticated, isGuest } = useAuth()
  // ゲスト・未認証時はフェッチをスキップ
  const swrKey = isAuthenticated && !isGuest ? '/api/friends/requests' : null
  const { data, error, isLoading, mutate } = useSWR(swrKey, fetcher)

  return {
    requests: data ?? DEFAULT_REQUESTS,
    loading: isLoading,
    error: error
      ? error instanceof Error
        ? error.message
        : 'フレンドリクエストの取得に失敗しました'
      : null,
    refetch: async () => {
      await mutate()
    },
  }
}
